import { ActionIcon, Paper, Stack } from '@mantine/core'
import { FaSync, FaPlus, FaMinus } from 'react-icons/fa'
import classes from './ZoomBox.module.css'

const ZoomBox = ({
  onZoomIn,
  onZoomOut,
  hideRefresh = false,
}: {
  onZoomIn: () => void
  onZoomOut: () => void
  hideRefresh?: boolean
}) => (
  <Stack gap="xs" className={classes.zoomStack}>
    {!hideRefresh && (
      <Paper shadow="xs" p={0} withBorder className={classes.actionButton}>
        <ActionIcon size={64} onClick={() => window.location.reload()} variant="default">
          <FaSync size={24} />
        </ActionIcon>
      </Paper>
    )}
    <Paper shadow="xs" p={0} withBorder className={classes.actionButton}>
      <ActionIcon size={64} onClick={onZoomIn} variant="default">
        <FaPlus size={24} />
      </ActionIcon>
    </Paper>
    <Paper shadow="xs" p={0} withBorder className={classes.actionButton}>
      <ActionIcon size={64} onClick={onZoomOut} variant="default">
        <FaMinus size={24} />
      </ActionIcon>
    </Paper>
  </Stack>
)

export default ZoomBox
